<template>
  <div class="input-wrapper">
    <!-- Label for the input -->
    <label :for="inputId" class="themeLabel">{{ label }} <span class="text-danger" v-if="required">*</span></label>

    <!-- Input Field -->
    <input :id="inputId" :type="type" :placeholder="placeholder" :value="value" @input="$emit('update:value', $event.target.value)" @focus="onFocus" @blur="onBlur" @click="onClick" :required="required" :readonly="readonly" :class="{ 'input-error': error, 'readonly-input': readonly }" />

    <!-- Error Message -->
    <div v-if="error" class="error-message">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
      </svg>
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'email', 'password', 'number'].includes(value),
    },
    placeholder: String,
    value: [String, Number],
    required: Boolean,
    readonly: { type: Boolean, default: false },
    inputId: String,
    error: String, // New prop for error message
    fieldErrors: {
      email: '',
      tenantId: '',
    },
  },
  emits: ['update:value'],
}
</script>

<style scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.input-wrapper input {
  width: 402px;
  height: 46px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f1f1f1;
  color: black;
  font-family: 'Archivo', sans-serif;
  font-size: 16px;
  font-weight: 400;
  box-sizing: border-box;
}

.input-wrapper input[readonly] {
  color: #8b8888;
  font-family: Archivo;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* Add border color when there's an error */
.input-error {
  border: 1px solid #e50006;
}

.input-wrapper input::placeholder {
  color: #363740;
}

/* Error Message Styling */
.error-message {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #e50006;
  font-family: Archivo;
  font-size: 12px;
  font-weight: 300;
  margin-top: 3px;
}
</style>
